<template>
  <div class="index">
    <div class="consultBox">
      <p class="consultTitle">快速求职</p>
      <div class="consultform">
        <div class="consultCenter"> 
          <el-form ref="formDom" :model="fD" :rules="rules" label-width="80px">
            <el-form-item label="姓名">
              <el-input v-model="fD.name" clearable placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="求职意向">
              <el-input v-model="fD.job" clearable type="textarea" :rows="4" placeholder="请输入求职意向"></el-input>
            </el-form-item>
            <el-form-item label="薪资范围">
              <el-select v-model="fD.salary" clearable style="width:190px;">
                <el-option v-for="(x,i) in salaryOptions" :key="i" :label="x" :value="x"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="到岗时间">
              <el-date-picker v-model="fD.workTime" type="date" value-format="timestamp" placeholder="请选择到岗时间" style="width:190px;"></el-date-picker>
            </el-form-item>
            <el-form-item label="所在地区">
              <div class="areaBox">
                <el-select v-model="areaIds[0]" clearable @change="remoteMethod(1)" placeholder="省" style="width:190px;">
                  <el-option v-for="(x,i) in province" :key="i" :label="x.name" :value="x.id"></el-option>
                </el-select>
                <el-select v-model="areaIds[1]" clearable @change="remoteMethod(2)" placeholder="市" style="width:190px;">
                  <el-option v-for="(x,i) in city" :key="i" :label="x.name" :value="x.id"></el-option>
                </el-select>
                <el-select v-model="areaIds[2]" clearable @change="remoteMethod(3)" placeholder="县" style="width:190px;">
                  <el-option v-for="(x,i) in county" :key="i" :label="x.name" :value="x.id"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="fD.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码">
              <el-input class="codeinput" v-model="fD.randomCode" width="300px"></el-input>
              <el-button style="margin-left:30px" type="info" :disabled="yzmData.disabled" @click="sendCode()">{{yzmData.str}}</el-button>
            </el-form-item>
            <div class="subBox"><el-button type="danger" @click="submit()">提交咨询</el-button> </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [ mixin_area ],
  props: ['tableData'],
  data() {
    let isPhone = (rule,value,callback)=>{
      let reg=/^1[3|4|5|7|8][0-9]\d{8}$/
      if (!reg.test(value)) {
        callback(new Error('手机号码不符合规范'))
      } else {
        callback()
      }
    };
    return {
      rules: {
        phone: [
          { required: 'true', message: '手机号不能为空', trigger: 'blur' },
          { validator: isPhone,trigger:'blur'}
        ],
      },
      fD: {}, // 表单对象
      salaryOptions: ['不限','面议','3k以下','3k-8k','8k-15k','15k以上'],

      province: [], // 表单里面的 省市县 的下拉框选项
      city: [],
      county: [],

      areaIds: [],

      yzmData: {
        codeTime: 180,
        disabled: false,
        str: '获取验证码'
      },
    }
  },
  computed: {
    provinceId() {
      return this.areaIds[0]
    },
    cityId() {
      return this.areaIds[1]
    }
  },
  methods: {
    //  获取位置
    areaGet(areaId, index) {
      this.$api.getPlace({areaId}).then(res => {
        if (res.data.status === 0 ) {
          let _R = JSON.parse(res.data.data)
          switch(index) {
            case 0 : this.province = _R;this.city = [];this.county = []; break
            case 1 : this.city = _R;this.county = []; break
            case 2 : this.county = _R; break
          }
        } else{ this._status(res.data) }
      })
    },
    //  清空下级
    remoteMethod(index) {
      switch(index) {
        case 1: this.areaIds[1] = this.areaIds[2] = ''; break;
        case 2: this.areaIds[2]= ''; break;
        case 3: break;
      }
    },
    //  发送验证码
    sendCode() {
      let phone = this.fD.phone
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (reg.test(phone)) {
        this.yzmData.disabled = true // 输入的号码格式正确，按钮变为不可点
        this.$api._user_SendCode({phone}).then(res => {
          if (res.data.status == 0) {
            let time = setInterval(() => {
              this.yzmData.codeTime--
              this.yzmData.str = '(' + this.yzmData.codeTime + ')秒后可重发'
              if (this.yzmData.codeTime <= 0 ) {
                clearInterval(time)
                this.yzmData.str = '获取验证码'
                this.yzmData.disabled = false
                this.yzmData.codeTime = 180
              }
            }, 1000)
          } else { this._status(res.data) }
        })
      } else { this.$message.warning('请输入正确的手机号码') }
    },
    //  提交表单
    submit() {
      this.$refs['formDom'].validate((valid)=>{
        if (valid) { // 验证通过
          let areaIdArr = this.areaIds.filter(x => x)
          this.fD.areaId = areaIdArr[areaIdArr.length - 1]

          this.$api.util_create('quickqiuzhi', this.fD).then(res => {
            if (res.data.status == 0) {
              this.$message.success('提交成功!')
              this.fD = {}
              this.areaIds = []
              this.$parent.getrequestData()
            } else { this._status(res.data) }
          })
        } else { return false }
      })
    },
    //  点击数据
    clickListData(item) {
      console.log(item)
    }
  },
  watch: {
    provinceId(val) {
      if (val == '') {
        this.areaGet(0, 0)
      } else {
        this.areaGet(val, 1)
      }
    },
    cityId(val) {
      if (val == '') {
        this.areaGet(this.areaIds[0], 1)
      } else {
        this.areaGet(val, 2)
      }
    }
  },
  created() {
    this.areaGet(0, 0)
  },
}
</script>

<style lang='scss' scoped>
/deep/.codeinput{width: 150px;}

.index{width: 960px;margin: 0 auto;}

.consultBox{width: 100%;border: 1px solid #eee;}
.consultBox .consultTitle:after{content: '';position: absolute;left: 10px;top: 14px;width: 3px;height: 24px;background-color: #ec0001;}
.consultBox .consultTitle{position: relative;padding-left: 20px;font-size: 18px;color: #333333;line-height: 50px;border-bottom: 1px solid #eee;}
.consultBox .consultform{padding: 15px;}
.consultBox .consultform input{height: 38px;}
.consultBox .consultform .consultCenter{padding: 20px 0px;width: 700px;margin: 0px auto;}
.consultBox .consultform .consultCenter .areaBox{display: flex;justify-content: space-between;}
.consultBox .consultform .consultCenter .areaBox div{width: 90%;}
.consultBox .consultform .consultCenter .subBox{padding: 20px 0px;}
.consultBox .consultform .consultCenter .subBox button{display: block;margin: 0px auto;}
.dataBox{width: 100%;margin-top: 15px;border: 1px solid #eee;}
.dataBox .datalist:hover{cursor: pointer;box-shadow: 0px 0px 20px #cccccc;}
.dataBox .datalist :hover .title{color: #1E9FFF;}
.dataBox .datalist{display: flex;height: 80px;padding: 15px;border-bottom: 1px solid #eeeeee;transition: all .2s;}
.dataBox .datalist .imgbox{display: block;margin-right: 15px;width: 80px;height: 80px;}
.dataBox .datalist .textcont{height: 80px;max-width: 830PX;flex: 1;}
.dataBox .datalist .textcont .title{width: 100%;line-height: 50px;font-size: 22px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-bottom: 10PX;}
.dataBox .datalist .textcont .info{line-height: 20PX;font-size: 14px;}
.dataBox .datalist .textcont .info span{display: inline-block;}
.dataBox .datalist .textcont .info span:nth-child(2){margin: 0px 30px;}
</style>